const COOKIES = {
  ACCESS_TOKEN: 'access_token',
  CAS: 'cas',
  FAILED_LOGIN: 'failedLogin',
  GA: '_ga',
  IS_LOGGED_IN: 'isLoggedIn',
  PERSON_TOKEN: 'PersonToken',
  WEB_VIEW: 'webview',
};

module.exports = COOKIES;
